import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["back"]

  connect() {
    this.position = history.state?.guideScroll
    this.fontsReady = false
    document.fonts.ready.then(() => {
      this.fontsReady = true
      this.restore()
    })

    // Keep the complete Discover URL, including search, district and locale.
    const source = document.referrer && new URL(document.referrer)
    if (source && source.origin === location.origin && source.pathname === "/discover") {
      this.returnURL = source.href
      this.backTargets.forEach(link => { link.href = this.returnURL })
    }
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }

  save() {
    history.replaceState({ ...history.state, guideScroll: this.position || { x: scrollX, y: scrollY } }, "")
  }

  restore(event) {
    // The page cache resumes this controller without calling connect again.
    // Its previous restore already consumed position, so read the saved entry.
    if (event?.type === "pageshow" && event.persisted) {
      this.position = history.state?.guideScroll
    }
    if (!this.position || !this.fontsReady) return
    if (this.element.querySelector(".guide-cards:not([data-state='ready'])")) return

    // React commits before the waterfall's animation frame. Wait for that
    // layout before scrolling, otherwise the short loading page clamps scrollY.
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => {
      this.frame = requestAnimationFrame(() => {
        if (!this.position) return
        window.scrollTo({ left: this.position.x, top: this.position.y, behavior: "instant" })
        this.position = null
      })
    })
  }

  back(event) {
    if (!this.returnURL || history.length <= 1 || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    history.back()
  }
}
